"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var combobox_1 = require("@reach/combobox");
var MissingDataSuggestions = function (_a) {
    var data = _a.data, popoverClassName = _a.popoverClassName;
    return (react_1.default.createElement(combobox_1.ComboboxPopover, { className: popoverClassName },
        react_1.default.createElement(combobox_1.ComboboxList, { "aria-label": "Places" }, data.map(function (item, index) {
            // getting the first part of the address without post index, city name and country name.
            var formatted_address = item.display_name.split(',')[0];
            return (react_1.default.createElement(combobox_1.ComboboxOption, { key: index, value: item.display_name },
                react_1.default.createElement("div", { className: "cb-option-inner" },
                    react_1.default.createElement("span", { className: "place-icon" },
                        react_1.default.createElement("i", { className: "cm-icon icon-location" })),
                    react_1.default.createElement("div", { className: "place-info" },
                        react_1.default.createElement("div", { dangerouslySetInnerHTML: {
                                __html: formatted_address,
                            } }),
                        react_1.default.createElement("div", { className: "secondary-text" }, item.display_name)))));
        }))));
};
exports.default = MissingDataSuggestions;
